import { cn } from "@/lib/utils";

type AdSize =
  | "leaderboard" // 728x90
  | "mobile-banner" // 320x100
  | "rectangle" // 300x250
  | "responsive";

interface AdSlotProps {
  size: AdSize;
  position?: string;
  className?: string;
}

const SIZE_CLASS: Record<AdSize, string> = {
  leaderboard: "w-[728px] h-[90px] max-w-full",
  "mobile-banner": "w-[320px] h-[100px] max-w-full",
  rectangle: "w-[300px] h-[250px] max-w-full",
  responsive: "w-full min-h-[100px]",
};

/**
 * Slot iklan placeholder. Nanti tinggal isi children dengan AdSense / publisher ad.
 * Saat slot kosong, render kotak transparan (tidak ditampilkan ke user).
 * Set `data-ad-debug="1"` di body untuk lihat outline saat dev.
 */
export function AdSlot({ size, position, className }: AdSlotProps) {
  // Empty ad slot — render nothing so it doesn't reserve vertical space.
  // When real ad code is wired up, restore the placeholder div with SIZE_CLASS.
  if (typeof document !== "undefined" && document.body?.dataset?.adDebug === "1") {
    return (
      <div
        data-ad-slot={position ?? size}
        aria-hidden="true"
        className={cn(
          "mx-auto my-4 flex items-center justify-center border border-dashed border-border text-xs text-muted-foreground/60",
          SIZE_CLASS[size],
          className,
        )}
      >
        ad: {position ?? size}
      </div>
    );
  }
  return null;
}